import { type AvatarEntityType } from "./avatarEntityTypes";

/** builds a full url to the given path, intended to be used with `services/router/Route` */
export const fullyQualifiedUrl = (pathname: string): string => {
  const url = new URL(window.location.href);
  url.pathname = pathname;
  return url.href;
};

const makeUrl = (pathname: string): string => {
  if (import.meta.env.REACT_APP_BACKEND_URL === "/") {
    return fullyQualifiedUrl(pathname);
  }
  if (import.meta.env.REACT_APP_BACKEND_URL) {
    const url = new URL(import.meta.env.REACT_APP_BACKEND_URL);
    url.pathname = pathname;
    return url.href;
  }
  throw new Error("please define REACT_APP_BACKEND_URL");
};

export type ImageResourceType = "Profile" | "room" | "event" | "organization" | "Bubbles";

export const makeImageResourceAvatarUrl = (resourceType: ImageResourceType, resourceId: string): string =>
  makeUrl(`/api/v1/${resourceType}/${resourceId}/picture`);

export function makeAvatarUrl(entityType: AvatarEntityType, entityId: string): string {
  switch (entityType) {
    case "profile":
      return makeImageResourceAvatarUrl("Profile", entityId);
    case "room":
      return makeImageResourceAvatarUrl("room", entityId);
    case "event":
      return makeImageResourceAvatarUrl("event", entityId);
    case "organization":
      return makeUrl(`/api/v1/Organization/${entityId}/picture`);
    case "bubble":
      return makeImageResourceAvatarUrl("Bubbles", entityId);
  }
}

export const makeProfileAvatarUrl = (userId: string): string => makeAvatarUrl("profile", userId);
export const makeRoomAvatarUrl = (roomId: string): string => makeAvatarUrl("room", roomId);
export const makeEventAvatarUrl = (eventId: string): string => makeAvatarUrl("event", eventId);
export const makeOrganizationAvatarUrl = (organizationId: string): string =>
  makeAvatarUrl("organization", organizationId);
export const makeBubbleAvatarUrl = (bubbleId: string): string => makeAvatarUrl("bubble", bubbleId);

export function getBubblePictureIdFromAvatarUri(avatarUri: string): string | undefined {
  const match = /\/Bubbles\/([^/?#]+)\/picture/i.exec(avatarUri);
  return match?.[1];
}
